import { NavLink, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../context/AuthContext";
import { requestWithoutToken } from "../utils/apis";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { useState } from "react";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters"),
  });

  const formik = useFormik({
    initialValues: { email: "", password: "" },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const payload = {
          email: values.email,
          password: values.password,
          type: "password",
        };

        const result = await requestWithoutToken("POST", "/api/user/signin", payload);

        if (result?.data.status) {
          const res = result.data.data;
          localStorage.setItem("token", res?.token);
          localStorage.setItem("shortcode", res?.project_shortcode);
          login();
          toast.success(result.data.message);
          navigate("/blogs");
        } else {
          toast.error(result.data.message);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="login-sec">
      <div className="login-form-sec">
        <form onSubmit={formik.handleSubmit}>
          <div className="login-form">
            <h1 className="heading1">Login to continue</h1>
            <p className="subheading">Enter your email address and password to access your account</p>
            <div className="frm-group">
              <label className="frm-label">Email</label>
              <input
                type="email"
                name="email"
                className={`frm-input ${formik.touched.email && formik.errors.email ? "error" : ""}`}
                placeholder="Enter your email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.email && formik.errors.email && (
                <div style={{ color: "red" }}>{formik.errors.email}</div>
              )}
            </div>
            <div className="frm-group">
              <label className="frm-label">Password</label>
              <input
                type="password"
                name="password"
                className={`frm-input ${formik.touched.password && formik.errors.password ? "error" : ""}`}
                placeholder="Enter your password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.password && formik.errors.password && (
                <div style={{ color: "red" }}>{formik.errors.password}</div>
              )}
            </div>
            <p className="logfooter">
              <NavLink to="/forgot-password" className="btn-link1">
                Forgot Password?
              </NavLink>
            </p>
            <div className="logbtn-group mt-4">
              <button type="submit" className="btn-black w-100">
                {loading ? <Spinner size="sm" /> : "Login"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
